import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Banner from '../sections/Banner/Banner';

const Home = () => {

    return (
        <>
            <Navbar/>
            <Banner/>
        </>
    );
};

export default Home;